/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Save_To_Space_File_Edited_ImageInputs */



/**
* | output |
* | --- |
* | "File: an image edited in this chat" |
*
* @param {Chat_Save_To_Space_File_Edited_ImageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_save_to_space_file_edited_image = /** @type {((inputs?: Chat_Save_To_Space_File_Edited_ImageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Save_To_Space_File_Edited_ImageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei: ein in diesem Chat bearbeitetes Bild")
	return /** @type {LocalizedString} */ ("File: an image edited in this chat")
});